import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { ArrowLeftRounded, ArrowRightRounded } from '@material-ui/icons';
import cx from 'clsx';
import { renderAnswer } from './renderAnswer';
export function renderCarousel(index, carousel, skillApi, cardId, onChange) {
    if (!carousel.contents)
        return null;
    var changePage = function (now, prev) {
        onChange(now, prev);
    };
    var carouselPages = carousel.contents.map(function (content) {
        return (React.createElement("div", { key: "carousel-".concat(cardId, "-").concat(carousel.id, "-").concat(content.id), className: cx('faq-answer-content__carousel-slide') }, renderAnswer(content, skillApi, cardId)));
    });
    return (React.createElement(React.Fragment, null, carouselPages && (React.createElement(Carousel, { index: index, swipe: true, NextIcon: React.createElement(ArrowRightRounded, null), PrevIcon: React.createElement(ArrowLeftRounded, null), navButtonsAlwaysVisible: true, indicatorIconButtonProps: {
            className: cx('faq-answer-content__carousel-indicator-button'),
        }, navButtonsProps: {
            className: cx('faq-answer-content__carousel-nav-button'),
        }, autoPlay: false, animation: 'slide', onChange: changePage }, carouselPages))));
}
//# sourceMappingURL=renderCarousel.js.map